import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Accordion } from "react-bootstrap";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import routes from "./moduleComsaRoutes";
import Sidebar from "../../../layout/Sidebar/Sidebar";
import Translator from "../../../layout/components/helpers/Translator";
import AppLink from "../../../routing/helpers/AppLink";
import { AppRemixIcon } from "@/layout/AppComponents";
import { axiosPath } from "@/routing/helpers/router";
import errorHandler from "@/layout/components/error/ErrorHandler";
import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import * as moduleAction from "../../../store/actions/moduleAction";

const ModuleComsaSideBarReports = (props) => {
  const { moduleData, activeRoute } = props;
  const { moduleBridgeHex, subModuleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();

  const permissions = useSelector(
    (s) => s.module[moduleBridgeHex]?.permissions,
  );

  // < STORE CALLS
  const loadModulePermissions = useCallback(async () => {
    try {
      await dispatch(
        moduleAction.fetch(
          axiosPath(
            "api_r_user_module_legalCompliance_evaluation_getPermissions",
          ),
          "permissions",
          {
            moduleBridgeHex,
            plantHex,
            subType: "permissions",
          },
        ),
      );
      await dispatch(
        moduleAction.fetch(
          axiosPath(
            "api_r_user_module_legalCompliance_evaluation_getPermissions",
          ),
          "userBridge",
          {
            moduleBridgeHex,
            plantHex,
            subType: "userBridge",
          },
        ),
      );
      await dispatch(
        moduleAction.fetch(
          axiosPath(
            "api_r_user_module_legalCompliance_evaluation_getPermissions",
          ),
          "jsonSettings",
          {
            moduleBridgeHex,
            plantHex,
            subType: "jsonSettings",
          },
        ),
      );
    } catch (err) {}
  }, [moduleBridgeHex, plantHex]);

  useEffect(() => {
    if (!permissions) loadModulePermissions();
  }, [moduleBridgeHex, plantHex]);
  // < STORE CALLS

  const handleReport = () =>
    axios
      .post(axiosPath("api_r_user_module_comsaReports_getXlsReport"), {
        moduleBridgeHex,
        subModuleBridgeHex,
        plantHex,
      })
      .then(({ data }) => (window.location = data))
      .catch((e) => dispatch(errorHandler(e)));

  const handleReportAlternative = () =>
    axios
      .post(axiosPath("api_r_user_module_comsaReports_getXlsReport2"), {
        moduleBridgeHex,
        subModuleBridgeHex,
        plantHex,
      })
      .then(({ data }) => (window.location = data))
      .catch((e) => dispatch(errorHandler(e)));

  return (
    <Sidebar>
      <Accordion>
        <ul>
          {routes.map((r, index) => {
            return (
              Object.keys(moduleData.indicators).includes(r.type) && (
                <li
                  key={index}
                  className={`${activeRoute === r.routeName ? "active" : ""}`}
                >
                  <AppLink
                    path={r.routeName}
                    params={{
                      moduleBridgeHex: moduleBridgeHex,
                      subModuleBridgeHex: subModuleBridgeHex,
                      plantHex: plantHex,
                    }}
                    className="p-0"
                  >
                    <span
                      className="sidebar-element"
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-comsaReports"
                          name={r.title}
                        />,
                      )}
                    >
                      {r.icon && (
                        <AppRemixIcon icon={r.icon} className="sidebar-icon" />
                      )}
                      <span className="sb-title">
                        <Translator file="module-comsaReports" name={r.title} />
                      </span>
                    </span>
                  </AppLink>
                </li>
              )
            );
          })}
          {permissions?.gcl?.module?.submodules?.comsa?.indicators?.exportXls ==
          "caixa" ? (
            <li>
              <span className="p-0" onClick={handleReportAlternative}>
                <span
                  className="sidebar-element"
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-comsaReports"
                      name="download.report"
                    />,
                  )}
                >
                  <AppRemixIcon icon="file-excel-2" className="sidebar-icon" />
                  <span className="sb-title">
                    <Translator
                      file="module-comsaReports"
                      name="download.report"
                    />
                  </span>
                </span>
              </span>
            </li>
          ) : (
            <li>
              <span className="p-0" onClick={handleReport}>
                <span
                  className="sidebar-element"
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-comsaReports"
                      name="download.report"
                    />,
                  )}
                >
                  <AppRemixIcon icon="file-excel-2" className="sidebar-icon" />
                  <span className="sb-title">
                    <Translator
                      file="module-comsaReports"
                      name="download.report"
                    />
                  </span>
                </span>
              </span>
            </li>
          )}
        </ul>
      </Accordion>
    </Sidebar>
  );
};

export default ModuleComsaSideBarReports;
